<template>
  <div id="app">
    <div class="section section-avatar">
      <work
        id="avatar"
        :image="avatar"
        title="乱序"
        subtitle="热爱钢琴的伪宅"
        :ratio="1"
        :width="225"
      ></work>
    </div>
    <div class="section section-recommand">
      <section-info
        title="游戏"
        subtitle="Game"
      ></section-info>
      <div class="container">
        <div
          class="work-container work-container-large"
          v-for="work in gameWorkList"
          :style="workContainerLargeStyle"
        >
          <work
            :title="work.title"
            :subtitle="work.subtitle"
            :image="work.image"
            :ratio="work.ratio"
            :width="work.width"
            :link="work.link"
          ></work>
        </div>
      </div>
    </div>
    <div class="section">
      <section-info
        title="站点"
        subtitle="Web site"
      ></section-info>
      <div class="container">
        <div
          class="work-container work-container-medium"
          v-for="work in siteWorkList"
          :style="workContainerMediumStyle"
        >
          <work
            :title="work.title"
            :subtitle="work.subtitle"
            :image="work.image"
            :ratio="work.ratio"
            :width="work.width"
            :link="work.link"
          ></work>
        </div>
      </div>
    </div>
    <div class="section">
      <section-info
        title="设计"
        subtitle="Design"
      ></section-info>
      <div class="container">
        <div
          class="work-container work-container-small"
          v-for="work in designWorkList"
          :style="workContainerSmallStyle"
        >
          <work
            :title="work.title"
            :subtitle="work.subtitle"
            :image="work.image"
            :ratio="work.ratio"
            :width="work.width"
            :link="work.link"
          ></work>
        </div>
      </div>
    </div>
    <div class="section">
      <section-info
        title="图形动画"
        subtitle="Motion Graphic"
      ></section-info>
      <div class="container">
        <div
          class="work-container work-container-small"
          v-for="work in mgWorkList"
          :style="workContainerSmallStyle"
        >
          <work
            :title="work.title"
            :subtitle="work.subtitle"
            :image="work.image"
            :ratio="work.ratio"
            :width="work.width"
            :link="work.link"
          ></work>
        </div>
      </div>
    </div>
    <div class="section">
      <section-info
        title="钢琴演奏"
        subtitle="Piano Playing"
      ></section-info>
      <div class="container">
        <div class="paper">
          <ul
            class="song-list"
          >
            <li
              class="song"
              v-for="song in songList"
            >
              <h1><a :href="song.link" target="_blank">{{ song.title }}</a></h1>
              <p>{{ song.subtitle }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="section">
      <section-info
        title="社交与联系"
        subtitle="Social & Contacts"
      ></section-info>
      <div class="container">
        <div class="paper">
          <ul
            class="contact-list"
          >
            <li
              class="contact"
              v-for="contact in contactList"
            >
              <h1 v-if="contact.link"><a :href="contact.link" target="_blank">{{ contact.title }}</a></h1>
              <h1 v-if="!contact.link">{{ contact.title }}</h1>
              <p>{{ contact.subtitle }}</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="section section-copyright">
      <p>{{ copyrightWording }}</p>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';

import Work from './components/Work';
import SectionInfo from './components/SectionInfo';

import avatar from './assets/avatar.jpg';

export default {
  components: {
    Work,
    SectionInfo,
  },
  data() {
    const gameWorkList = [
      {
        title: 'KAMELEON',
        subtitle: '色彩的调和与收集',
        image: 'game-kameleon.jpg',
        ratio: 16 / 9,
        width: 0.85,
        link: 'http://www.kameleongame.com',
      },
      {
        title: 'RIPPLE',
        subtitle: '涟漪的扩散',
        image: 'game-ripple.png',
        ratio: 16 / 9,
        width: 0.85,
        link: 'http://mida.re/works/game/ripple/',
      },
      {
        title: 'SNAKE',
        subtitle: '贪食蛇的简单实现',
        image: 'game-snake.png',
        ratio: 16 / 9,
        width: 0.85,
        link: 'http://mida.re/works/game/snake/',
      },
    ];

    const siteWorkList = [
      {
        title: '开眼 Eyepetizer',
        subtitle: '开眼的全部 Web 页面',
        image: 'site-eyepetizer.jpg',
        ratio: 3 / 2,
        width: 0.75,
        link: 'http://www.wandoujia.com/eyepetizer/',
      },
      {
        title: '分子互动',
        subtitle: '综合性公司网站',
        image: 'site-fenz.png',
        ratio: 3 / 2,
        width: 0.75,
        link: 'http://fen-z.com',
      },
      {
        title: '人间 JINKAN',
        subtitle: '滚动渐变',
        image: 'site-jinkan.jpg',
        ratio: 3 / 2,
        width: 0.75,
        link: 'http://mida.re/works/site/jinkan/',
      },
      {
        title: '数字媒体艺术',
        subtitle: '就读专业的介绍',
        image: 'site-digitalarts.jpg',
        ratio: 3 / 2,
        width: 0.75,
        link: 'http://mida.re/works/site/digitalarts/',
      },
      {
        title: '温州君顶会所',
        subtitle: '无滚动条的全屏显示',
        image: 'site-wzjunding.jpg',
        ratio: 3 / 2,
        width: 0.75,
        link: 'http://mida.re/works/site/wenzhoujunding/',
      },
      {
        title: '伪鸟居',
        subtitle: 'CSS 3D 变换',
        image: 'site-torriacg.jpg',
        ratio: 3 / 2,
        width: 0.75,
        link: 'http://mida.re/works/site/torriacg/',
      },
    ];

    const designWorkList = [
      {
        title: '樱花科技宣传',
        subtitle: 'AI 矢量绘图',
        image: 'design-ssbanner.jpg',
        ratio: 16 / 9,
        width: 0.85,
        link: 'image',
      },
      {
        title: '硬盘图标',
        subtitle: '简单的图层样式应用',
        image: 'design-hddicon.jpg',
        ratio: 1,
        width: 0.7,
        link: 'image',
      },
      {
        title: '天文社海报',
        subtitle: '中规中矩',
        image: 'design-astro.jpg',
        ratio: 720 / 1018,
        width: 0.7,
        link: 'image',
      },
    ];

    const mgWorkList = [
      {
        title: 'Equally 字体',
        subtitle: 'Keynote 动画',
        image: 'mg-equally.jpg',
        ratio: 1,
        width: 0.7,
        link: 'http://v.youku.com/v_show/id_XNTQ0NTkwOTcy.html',
      },
      {
        title: '春日祭 LOGO 演示',
        subtitle: 'Keynote 动画',
        image: 'mg-kasuga.jpg',
        ratio: 1,
        width: 0.7,
        link: 'http://v.youku.com/v_show/id_XNTQ0NzM4NDA4.html',
      },
      {
        title: '数媒网站规范',
        subtitle: 'Keynote 动画',
        image: 'mg-da.jpg',
        ratio: 16 / 9,
        width: 0.8,
        link: 'http://v.youku.com/v_show/id_XNzMwMjUxODYw.html',
      },
    ];

    const songList = [
      {
        title: '時を刻む唄',
        subtitle: '「CLANNAD ～AFTER STORY～」OP',
        link: 'http://www.bilibili.com/video/av4289560/',
      },
      {
        title: 'When You Wish Upon A Star',
        subtitle: '「Pinocchio」IN',
        link: 'http://www.bilibili.com/video/av3829648/',
      },
      {
        title: 'Someday My Prince Will Come',
        subtitle: '「Snow White and the Seven Dwarfs」IN',
        link: 'http://www.bilibili.com/video/av3024599/',
      },
      {
        title: 'Zzz',
        subtitle: '「日常」ED',
        link: 'http://www.bilibili.com/video/av3001231/',
      },
      {
        title: '少年たちとの別れ ～piano only～',
        subtitle: '「リトルバスターズ!」OST',
        link: 'http://www.bilibili.com/video/av2463740/',
      },
      {
        title: '無題『恋心を奏でる綺想曲』',
        subtitle: '「リトルバスターズ!」OST',
        link: 'http://www.bilibili.com/video/av2463736/',
      },
      {
        title: '薔薇の花びらが舞うように',
        subtitle: '「氷菓」OST',
        link: 'http://www.bilibili.com/video/av2214262/',
      },
      {
        title: 'Old Memory',
        subtitle: '「ヨスガノソラ」OST',
        link: 'http://www.bilibili.com/video/av2163207/',
      },
      {
        title: 'ソリテュード',
        subtitle: '「甘城ブリリアントパーク」OST',
        link: 'http://www.bilibili.com/video/av2042592/',
      },
      {
        title: '相合傘',
        subtitle: '「月刊少女野崎くん」OST',
        link: 'http://www.bilibili.com/video/av1585251/',
      },
      {
        title: 'POWDER SNOW',
        subtitle: '「WHITE ALBUM」IN',
        link: 'http://www.bilibili.com/video/av1522352/',
      },
      {
        title: 'えきぞちっく・といぼっくす',
        subtitle: '「リトルバスターズ!」OST',
        link: 'http://www.bilibili.com/video/av1500083/',
      },
      {
        title: '降り続く雨の街で',
        subtitle: '「リトルバスターズ!」OST',
        link: 'http://www.bilibili.com/video/av926721/',
      },
      {
        title: 'WHITE ALBUM',
        subtitle: '「WHITE ALBUM 2」EP1·ED',
        link: 'http://www.bilibili.com/video/av922102/',
      },
      {
        title: '「戦场ヶ原、荡れ」',
        subtitle: '「化物語」OST',
        link: 'http://www.bilibili.com/video/av922045/',
      },
      {
        title: '见果てぬ梦',
        subtitle: '「WHITE ALBUM 2」OST',
        link: 'http://www.bilibili.com/video/av921656/',
      },
    ];

    const contactList = [
      {
        title: 'midare#utakana.de',
        subtitle: 'Email & QQ, (#)=>@',
      },
      {
        title: 'http://midare.utakana.de',
        subtitle: '博客「即兴之歌」',
        link: 'http://midare.utakana.de',
      },
      {
        title: 'http://zhihu.com/people/midare',
        subtitle: '知乎',
        link: 'http://zhihu.com/people/midare',
      },
    ];

    /* eslint-disable global-require */
    _.each([
      gameWorkList,
      siteWorkList,
      designWorkList,
      mgWorkList,
    ], (workList) => {
      _.each(workList, (work) => {
        work.image = require(`./assets/works/${work.image}`);

        if (work.link === 'image') {
          work.link = work.image;
        }
      });
    });
    /* eslint-enable */

    return {
      avatar,
      gameWorkList,
      siteWorkList,
      designWorkList,
      mgWorkList,
      songList,
      contactList,
      containerWidth: window.innerWidth,
      copyrightWording: `©${(new Date()).getFullYear()} midare. Some rights reserved.`,
    };
  },
  computed: {
    workContainerLargeStyle() {
      if (this.containerWidth < 768) {
        return {
          height: `${this.containerWidth * 1.1}px`,
        };
      }

      return {
        height: `${this.containerWidth * 0.75}px`,
      };
    },
    workContainerMediumStyle() {
      if (this.containerWidth < 768) {
        return {
          height: `${this.containerWidth * 1.1}px`,
        };
      }

      return {
        height: `${this.containerWidth / 2 * 0.8}px`,
      };
    },
    workContainerSmallStyle() {
      if (this.containerWidth < 768) {
        return {
          height: `${this.containerWidth * 1.1}px`,
        };
      }

      return {
        height: `${this.containerWidth / 3 * 1.3}px`,
      };
    },
  },
  ready() {
    this.containerWidth = document.querySelector('.container').offsetWidth;

    window.onresize = () => {
      this.containerWidth = document.querySelector('.container').offsetWidth;
    };
  },
};
</script>

<style lang="scss">
* {
  box-sizing: border-box;
}

html {
  height: 100%;
}

body {
  background-image: radial-gradient(circle at 50% 50%,#fff 0,#e6e6e6 100%);
  color: #999;
  font-family: 'HanHei SC', 'PingFang SC', 'Helvetica Neue', 'Helvetica', 'STHeitiSC-Light', 'Arial', sans-serif;
  height: 100%;
  line-height: 1.5;
  margin: 0;
}

a {
  color: #999;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
}

h1,
h2,
h3,
h1 a,
h2 a,
h3 a, {
  color: #333;
}

h1,
h2,
h3,
p, {
  // margin: 6px 0;
}

#app {
  height: 100%;
}

.section {
  // border-top: 1px solid rgba(51, 51, 51, 0.3);
  margin-bottom: 36px;

  &:first-child {
    border-top: none;
  }

  &-avatar {
    height: 100%;
  }

  &-copyright {
    font-size: 12px;
    margin-bottom: 0;
    text-align: center;
    padding-bottom: 36px;

    p {
      margin: 0;
    }
  }
}

.container {
  margin: 0 auto;
  max-width: 1024px;
  width: 100%;
}

.work-container {
  position: relative;

  &-large {
    width: 100%;
  }

  &-medium {
    display: inline-block;
    width: 50%;
  }

  &-small {
    display: inline-block;
    width: 33.33%;
  }

  .work {
    left: 50%;
    position: absolute;
    top: 50%;
    transform: translate3d(-50%, -50%, 0);
  }
}

#avatar {
  left: 50%;
  position: absolute;
  top: 50%;
  transform: translate3d(-50%, -50%, 0);
}

.paper {
  background: #fff;
  border-radius: 9px;
  // box-shadow: 0px 2px 6px 0px rgba(0,0,0,0.2);
  margin: 0 auto;
  padding: 12px;
  width: 90%;
  max-width: 340px;

  ul {
    padding-left: 1.5em;
  }

  li {
    margin: 12px 0;
  }

  h1 {
    font-size: 14px;
    margin: 0;
  }

  p {
    font-size: 12px;
    margin: 0;
  }
}

@media (max-width: 768px) {
  .work-container {

    &-medium {
      width: 100%;
    }

    &-small {
      width: 100%;
    }
  }
}
</style>



/** WEBPACK FOOTER **
 ** App.vue?1de8c52c
 **/